import React from 'react';
import Button from './Button';
import  useScrollToTop from './useScrollToTop';
import mediumHouseOverview from '../img/elevation_img_11.avif'; // Replace with your actual image
import mediumHouseGroundFloor from '../img/elevation_img_11.avif'; // Replace with your actual image
import mediumHouseFirstFloor from '../img/elevation_img_11.avif'; // Replace with your actual image
import comfortableLiving from '../img/elevation_img_11.avif'; // Replace with your actual image
import balancedHouseExterior from '../img/elevation_img_11.avif'; // Replace with your actual image
import locationMap from '../img/elevation_img_11.avif'; // Replace with your actual image
import './ProjectStyles.css';

const HousePlan30x40 = () => {
  useScrollToTop();
  return (
    <div className='project-container'> {/* Using the general project container style */}
      <h2>Comfortable 30x40 House Plan (1200 sq ft): Balancing Space and Functionality</h2>
      <img className='project-image' src={mediumHouseOverview} alt="30x40 House Overview" loading="lazy" />
      <div className='project-details'>
        <p>Discover a well-proportioned two-story house plan designed for a 30x40 sq ft plot (1200 sq ft). This design strikes a balance between ample living space and efficient functionality, making it a great choice for families in urban settings like Patna, Bihar.</p>

        <h3>Design Philosophy: Harmonious Living Spaces</h3>
        <p>The core of this design is to create a comfortable and harmonious living environment across two floors. With a larger footprint than the 20x40 plan, this design allows for more distinct and generously sized rooms while maintaining efficient flow and good natural light and ventilation.</p>

        <h3>Inspiration for Family Comfort</h3>
        <div className='inspiration-gallery'>
          {/* Replace with images inspiring comfortable family homes */}
          <img src='../img/spacious_living_room.jpg' alt='Comfortable Home Inspiration 1' className='project-image' />
          <img src='../img/functional_family_kitchen.jpg' alt='Comfortable Home Inspiration 2' className='project-image' />
          <img src='../img/cozy_bedroom_design.jpg' alt='Comfortable Home Inspiration 3' className='project-image' />
          {/* Add more inspiration images as needed */}
        </div>
      </div>

      <div className='project-details'>
        <h3>Detailed Floor Plans: Well-Defined Living Zones</h3>
        <div className='floor-plan-section'>
          <h4>Ground Floor Plan (Approx. 600 sq ft)</h4>
          <img className='project-image' src={mediumHouseGroundFloor} alt="Ground Floor Plan" loading="lazy" />
          <p>The ground floor typically features a more spacious living room, a well-defined kitchen with a dining area, a common bathroom, and potentially a guest bedroom or a study. The layout allows for comfortable movement and interaction between different areas.</p>
          <ul>
            <li><strong>Spacious Living Room</strong></li>
            <li><strong>Well-Designed Kitchen with Dining Area</strong></li>
            <li><strong>Guest Bedroom/Study Option</strong></li>
            <li><strong>Common Bathroom</strong></li>
            <li><strong>Staircase to the First Floor</strong></li>
            <li>Potential for a small front porch or garden area</li>
          </ul>
          {/* Add specific room dimensions and features here */}
        </div>

        <div className='floor-plan-section'>
          <h4>First Floor Plan (Approx. 600 sq ft)</h4>
          <img className='project-image' src={mediumHouseFirstFloor} alt="First Floor Plan" loading="lazy" />
          <p>The first floor usually accommodates the main bedrooms, including a master bedroom with an attached bathroom, and one or two additional bedrooms, along with another bathroom. A small family lounge or balcony might also be included.</p>
          <ul>
            <li><strong>Master Bedroom with Attached Bathroom</strong></li>
            <li><strong>One or Two Additional Bedrooms</strong></li>
            <li><strong>Common Bathroom</strong></li>
            <li>Potential for a Family Lounge Area</li>
            <li>Balcony Option</li>
          </ul>
          {/* Add specific room dimensions and features here */}
        </div>

        <div className='built-area-breakdown'>
          <h4>Built Area Breakdown (Approximate)</h4>
          <ul>
            <li><strong>Ground Floor:</strong> ~600 sq ft</li>
            <li><strong>First Floor:</strong> ~600 sq ft</li>
            <li><strong>Total Built Area:</strong> ~1200 sq ft</li>
            <p>*Note: These are approximate figures and can vary based on the specific architectural design.</p>
          </ul>
        </div>
      </div>

      <div className='project-details'>
        <h3>Comfortable Interiors: Balancing Space and Light</h3>
        <div className='interior-feature'>
          <h4>Well-Lit and Ventilated Rooms</h4>
          <img className='project-image' src={comfortableLiving} alt="Comfortable Living Area" loading="lazy" />
          <p>With a larger footprint, this design allows for more generous window sizes and placements, ensuring ample natural light and good cross-ventilation throughout the home.</p>
        </div>

        <div className='interior-feature'>
          <h4>Defined Living Zones</h4>
          <p>The layout allows for more clearly defined living spaces, providing a sense of order and functionality for family life.</p>
        </div>

        <div className='interior-feature'>
          <h4>Flexibility in Room Usage</h4>
          <p>The additional space offers more flexibility in how rooms can be used and adapted to the family's evolving needs.</p>
        </div>

        {/* Add more interior design considerations for a medium-sized home */}
      </div>

      <div className='project-details'>
        <h3>Practical Exterior: Appealing and Durable</h3>
        <img className='project-image' src={balancedHouseExterior} alt="House Exterior" loading="lazy" />

        <div className='exterior-feature'>
          <h4>Balanced Proportions</h4>
          <p>The 30x40 plot allows for a well-proportioned exterior design that can be both aesthetically pleasing and functional.</p>
        </div>

        <div className='exterior-feature'>
          <h4>Durable and Climate-Appropriate Materials</h4>
          <p>Selecting materials that are durable and suitable for the climate of Patna will ensure the longevity and low maintenance of the house.</p>
        </div>

        {/* Add more exterior design features */}
      </div>

      <div className='project-details'>
        <h3>Quality Considerations for Your 1200 sq ft Home</h3>
        <div className='materials-list'>
          <h4>Material Considerations</h4>
          <ul>
            <li><strong>Structure:</strong> Reinforced Concrete (designed for local seismic conditions)</li>
            <li><strong>Exterior Walls:</strong> Brick masonry with appropriate plastering and finish</li>
            <li><strong>Roofing:</strong> Durable and insulated roofing system to manage heat</li>
            <li><strong>Windows and Doors:</strong> Quality frames and glazing for energy efficiency and security</li>
            <li><strong>Flooring:</strong> Durable and aesthetically pleasing options like tiles or marble</li>
          </ul>
        </div>

        {/* Optional: Vaastu considerations for a medium-sized plot */}
      <h4>Vaastu Shastra Considerations </h4>
        <p>With a more generous plot size, incorporating Vaastu principles for optimal energy flow and harmony within the home becomes more feasible. Considerations for room orientations and placements can be integrated into the design.</p>
      </div>

      {/* Optional: Location and Context in Patna */}
     <div className='project-details'>
        <h3>Suitable for Residential Areas in Patna</h3>
        {locationMap && <img className='project-image' src={locationMap} alt="Location Map" />}
        <p>This 30x40 house plan is well-suited for many residential areas in Patna, offering a comfortable and spacious living environment for families.</p>
        <div className='location-details'>
          <h4>Local Considerations</h4>
          <ul>
            <li>Fits comfortably on standard residential plots in Patna.</li>
            <li>Allows for a good balance of indoor and potential outdoor space.</li>
            <li>Designed with consideration for local building practices and climate.</li>
          </ul>
        </div>
      </div> 

      <div className='project-details call-to-action'>
        <h3>Ready to Build Your Comfortable Family Home?</h3>
        <p>This balanced 30x40 two-story house plan offers a great foundation for creating a comfortable and functional home for your family in Patna. Connect with experienced architects and builders to customize this plan to your specific needs and local building codes.</p>
        {/* Add your contact information or links to architectural services */}
        <a href="https://wa.me/918828531570" target="_blank" rel="noopener noreferrer">
                 <Button className="button-outlined">Discuss Your Custom Design</Button>
                </a>
      </div>
    </div>
  );
};

export default HousePlan30x40;